<template>
  <router-view> </router-view>
</template>

<script>
// Store
import { mapState } from 'vuex'

// Component
export default {
  components: {},
  props: {},
  computed: {
    ...mapState('survey', ['survey']),
  },
}
</script>

<style lang="scss" scoped></style>
